/*global jQuery */
void (function themeStart($) {
	'use strict';

	// Throttle
	// Lifted from underscore.js (https://github.com/jashkenas/underscore/blob/master/underscore.js)
	/* eslint-disable */
	function throttle(func, wait, options) {
		var timeout, context, args, result;
		var previous = 0;
		if (!options) {
			options = {};
		}

		function later() {
			previous = options.leading === false ? 0 : new Date().getTime();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) {
				context = args = null;
			}
		}

		function throttled() {
			var now = new Date().getTime();
			if (!previous && options.leading === false) {
				previous = now;
			}

			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}

				previous = now;
				result = func.apply(context, args);
				if (!timeout) {
					context = args = null;
				}
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}

			return result;
		}

		throttled.cancel = function cancelThrottle() {
			clearTimeout(timeout);
			previous = 0;
			timeout = context = args = null;
		};

		return throttled;
	}
	/* eslint-enable */

	// // EVENT BINDINGS // //

	const scrollThrottleThreshold = 100;
	const resizeThrottleThreshold = 100;
	$(document).ready(() => {
		const $staticCTA = $('.cta__static');
		const $stickyCTA = $('.cta__sticky');
		if ($staticCTA.length === 0 || $stickyCTA.length === 0) {
			return;
		}

		const $scrollTop = $('#ScrollTop');
		let activeCTA = 'stickyCTA';
		let staticCTAOffset = $staticCTA.offset().top;
		let viewportHeight = $(window).outerHeight();
		let CTAHeight = $staticCTA.outerHeight();

		$(window).on(
			'resize',
			throttle(() => {
				staticCTAOffset = $staticCTA.offset().top;
				viewportHeight = $(window).outerHeight();
				CTAHeight = $staticCTA.outerHeight();
			}, resizeThrottleThreshold),
		);

		$(window).on(
			'scroll',
			throttle(() => {
				const scrollTop = parseInt($scrollTop.val(), 10);
				if (
					scrollTop + (viewportHeight - CTAHeight) >
					staticCTAOffset
				) {
					if (activeCTA !== 'staticCTA') {
						$stickyCTA.attr('aria-hidden', true);
						$staticCTA.attr('aria-hidden', false);
						activeCTA = 'staticCTA';
					}
				} else {
					if (activeCTA !== 'stickyCTA') {
						$stickyCTA.attr('aria-hidden', false);
						$staticCTA.attr('aria-hidden', true);
						activeCTA = 'stickyCTA';
					}
				}

				const half = 0.5;
				if (scrollTop > staticCTAOffset * half) {
					if (!$stickyCTA.hasClass('cta__hiding')) {
						$stickyCTA.addClass('cta__hiding');
					}
				} else {
					if ($stickyCTA.hasClass('cta__hiding')) {
						$stickyCTA.removeClass('cta__hiding');
					}
				}
			}, scrollThrottleThreshold),
		);
	});
})(jQuery);
